// extracted by mini-css-extract-plugin
export default {"container":"ContactInfo_container__zdz8a","closeButton":"ContactInfo_closeButton__-tFUK","light":"ContactInfo_light__WyF4O","semibold":"ContactInfo_semibold__qnInr"};